'use strict';

namespace TR {
    class SelectDomain {

        permittedRegions;
        lightbox: boolean = false;
        officeLocations;

        constructor(
            private cookieService,
            private $location: ng.ILocationService,
            private agentModeService,
            private globalisationService,
            private dateUtil
        ) {
            this.lightbox = true;

            this.agentModeService.getAgentInformation().then(data => {
                const permittedDomains = data.PermittedDomains;
                this.officeLocations = data.OfficeLocations;
                this.globalisationService.getAllDomains().then(allDomains => {
                    const currentDomain = allDomains.filter(d => d.Id === TRPCONFIG.Domain.DomainId)[0];
                    const parentDomainId = currentDomain.ParentId ? currentDomain.ParentId : TRPCONFIG.Domain.DomainId;
                    const parentSubDomains = allDomains.filter(d => d.ParentId === parentDomainId);
                    if (permittedDomains.length === 0) {
                        this.permittedRegions = parentSubDomains;
                    }
                    else {
                        this.permittedRegions = parentSubDomains.filter(d => permittedDomains.indexOf(d.Id) !== -1);
                        if (this.permittedRegions.length === 1) {
                            this.setSelectedDomain(this.permittedRegions[0].Id);
                        }
                    }
                });
            });
        }

        setSelectedDomain(selectedDomain) {
            this.cookieService.set('SubDomainID', selectedDomain, this.dateUtil.addDays(new Date(), 365));
            if (this.officeLocations.length === 1) {
                this.agentModeService.setOfficeLocation(this.officeLocations[0].Id).then(() => {
                    window.location.href = this.$location.absUrl().replace('selectdomain', '');
                });
            } else {
                this.$location.path('selectoffice');
            }
        }

    }

    angular
    .module('TR')
    .controller('SelectDomain', SelectDomain);
}
